import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AppShell } from '@/components/layout';

/**
 * Layout wrapper for protected routes
 * Wraps all authenticated pages with ProtectedRoute and AppShell
 */
export function ProtectedLayout() {
  return (
    <ProtectedRoute requireTenant>
      <AppShell>
        <Outlet />
      </AppShell>
    </ProtectedRoute>
  );
}
